export default __webpack_public_path__ + "static/media/r3.7dd48ebf.jpg";